// PrivateRoute.tsx in v6
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import AdminNavBar from "./admin/AdminNavBar";
import AdminSideBar from "./admin/AdminSideBar";
import IgniteFooter from "./IgniteFooter";
import { getSubsite } from "../reducers/auth";

const AdminRoute = ({ children }) => {
  let location = useLocation();
  const currentSubsite = useSelector(getSubsite);
  const { isAdmin, isSuperAdmin, loading } = useSelector(state => state.auth);

  if (loading) {
    return <p>Checking authenticaton..</p>;
  }

  if (!isAdmin && !isSuperAdmin) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return (
    <>
    <AdminNavBar />
    <div className="container" style={{marginBottom: 100}}>
      <div class="admin-container">
        <div class="admin-side-nav">
          <AdminSideBar />
        </div>
        <div class="admin-content">
          {children}
        </div>
      </div>
    </div>
    <IgniteFooter menuBgColor={currentSubsite?.subsite_content?.menuBgColor} menuTextColor={currentSubsite?.subsite_content?.menuTextColor} menuTextHoverColor={currentSubsite?.subsite_content?.menuTextHoverColor}/>
    </>
  ) 
};

export default AdminRoute;